<template>
  <div class="coverage">
    <table v-if="isEmpty || isLoading">
      <thead>
        <tr>
          <th v-for="(header, index) in data.header" :key="index">{{header}}</th>
        </tr>
      </thead>
      <tbody class="loading" v-if="!isEmpty">
        <tr >
          <td :colspan="data.header.length">
            <adx-loading-primary />
          </td>
        </tr>
      </tbody>
      <tbody class="empty" v-if="!isLoading">
        <tr >
          <td :colspan="data.header.length">
            <div class="emptyState">
              <h4>Nothing to show right now</h4>
              <p class="small-font">Please modify your filter or change your search</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <adx-list-item v-else :data='data' :type="`bar`" />
  </div>
</template>

<script>
import ListItem from '@/components/ListDemographic'
import LoadingPrimary from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'
import lib from '@/lib/util'
import moment from 'moment'
import axios from 'axios'

import { parseErrorGql } from '@/lib/error'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { restEdge } from "@/api/edgeUrls"
import { apiUrls } from '@/api/measurementUrls'

export default {
  name: 'adx-campaignreport-demographic-age',
  components: {
    'adx-list-item': ListItem,
    'adx-loading-primary': LoadingPrimary,
    'adx-empty-selection': EmptySelection
  },
  props: {
    start_date: {
      type: String,
      required: false
    },
    end_date: {
      type: String,
      required: false
    },
    idParent: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      data: {
        header: ['Coverage Area', 'Percentage (%)'],
        body: []
      },
      report: [],
      isEmpty: false,
      isLoading : true
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      const params = {
        start: this.start_date,
        end: this.end_date
      }

      const { data, status } = await api.get(apiUrls.busCoverageSummary(this.idParent), 
      { params: params, 
        needToken: false,
        useMeasurement: true
      })

      if (status === 200 && data.length) {
        const orderedData = _.orderBy(data, ['totalHours'], ['desc'])
  
        // let total = orderedData.reduce((prev, curr) => prev + (curr.percentage || 0), 0)
  
        // Order and calculate data
        this.data.body = orderedData.map(data => {
          // let percentage = Math.round(data.percentage/total * 100)
          if (data.percentage !== 0) {
            return {
              coverage: data.city,
              percent1: data.percentage
            }
          }
        })
      } else {
        this.isEmpty = true
      }

      this.isLoading = false
    },
    getFormatNumber(value){
      return formatMoney(value, { symbol: ``, precision: 0, thousand: `.` })
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
// .routes{
  .listDemographic{
    table{
      thead{
        tr{
          th{
            font-size: 12px
          }
        }
      }
    }
  }
</style>
